export const SET_CURRENT_VTO = 'SET_CURRENT_VTO';
export const TOGGLE_VTO = 'TOGGLE_VTO';
export const SET_VTO_MESSAGE = 'SET_VTO_MESSAGE';
export const RESET_VTO_MESSAGE = 'RESET_VTO_MESSAGE';
